// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"src-hellospa-components-checkbox-checkbox__checkbox--250bm","label":"src-hellospa-components-checkbox-checkbox__label--2Umn7"};